<template>
  <div>
    <Loading :active="isLoading" :is-full-page="true" />
    <HeaderDashboard :currentUser="currentUser" />

    <div style="background: #eef1f5; padding-bottom: 50px">
      <CStack v-if="results.length">
        <CBox m="20px auto" w="80%">
          <CFlex align="center" justify="flex-start" w="100%">
            <CHeading color="#16ABF8" size="lg">
              Hasil Evaluasi Kontrak Kerja
            </CHeading>
          </CFlex>
          <CDivider />

          <CBox mb="30px" v-for="(item, index) in results" :key="index">
            <CFlex align="center" justify="flex-start" mt="15px" w="100%">
              <CText
                fontSize="xl"
                ml="10px"
                fontWeight="400"
                whiteSpace="pre-line"
              >
                {{ item }}
              </CText>
            </CFlex>
          </CBox>
        </CBox>
      </CStack>
      <CStack v-else h="100%" spacing="1" w="80%" m="auto">
        <CBox
          bg="#fff"
          boxShadow="1px 1px #C7C7C7"
          mt="40px"
          p="20px"
          rounded="10px"
        >
          <CHeading color="#16ABF8" size="lg"> Apa Itu Contractpal? </CHeading>
          <CDivider />
          <CBox>
            ContractPal adalah teman AI Anda yang mengevaluasi jargon kontrak
            yang terasa seperti obrolan ramah. ContractPal menerjemahkan kontrak
            ke dalam bahasa yang sederhana, mengirimkan peringatan untuk detail
            yang terlewatkan, dan memastikan kepatuhan terhadap hukum Indonesia
            dalam satu solusi yang lancar.
          </CBox>
        </CBox>

        <CBox
          bg="#fff"
          boxShadow="1px 1px #C7C7C7"
          mt="20px"
          p="20px"
          rounded="10px"
        >
          <CFlex
            align="center"
            justify="center"
            h="300px"
            direction="column"
            gap="2"
          >
            <input
              type="file"
              multiple="false"
              ref="file"
              @change="handleFileUpload($event)"
            />

            <ButtonBlue
              mt="30px"
              label="Analisis Kontrak"
              size="md"
              rounded="45px"
              @click.native="submit()"
            />
          </CFlex>
          <CDivider />
          <CHeading color="#16ABF8" size="md" textAlign="center" mt="10px">
            Apa Yang Dievaluasi?
          </CHeading>
          <CFlex
            align="center"
            justify="space-between"
            mt="15px"
            wrap="wrap"
            w="100%"
          >
            <CCheckbox
              size="md"
              w="30%"
              v-for="(item, counter) in evaluateTexts"
              :key="counter"
              default-is-checked
              @change="
                (val, $e) => checkboxHandler(counter, $e?.target?.checked)
              "
              >{{ item.label }}</CCheckbox
            >
          </CFlex>
        </CBox>

        <CBox
          bg="#fff"
          boxShadow="1px 1px #C7C7C7"
          mt="20px"
          p="20px"
          rounded="10px"
        >
          <CHeading color="#16ABF8" size="lg">
            Apa Yang Akan Kamu Dapatkan?
          </CHeading>
          <CDivider />
          <CFlex
            align="center"
            justify="space-between"
            mt="15px"
            wrap="wrap"
            w="100%"
          >
            <CFlex w="30%" align="center" justify="center" direction="column">
              <svg
                width="85"
                height="85"
                viewBox="0 0 85 85"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M78.3417 62.4465L49.5333 12.4164C48.8134 11.1907 47.7857 10.1744 46.552 9.46827C45.3183 8.76211 43.9215 8.39062 42.5 8.39062C41.0785 8.39062 39.6817 8.76211 38.448 9.46827C37.2144 10.1744 36.1866 11.1907 35.4667 12.4164L6.65835 62.4465C5.96568 63.6321 5.60065 64.9805 5.60065 66.3535C5.60065 67.7266 5.96568 69.075 6.65835 70.2605C7.36902 71.4937 8.39499 72.5155 9.63097 73.2212C10.867 73.9269 12.2684 74.291 13.6916 74.2763H71.3084C72.7305 74.2899 74.1306 73.9252 75.3653 73.2195C76.6 72.5139 77.625 71.4927 78.3351 70.2605C79.0288 69.0756 79.3949 67.7275 79.3961 66.3544C79.3972 64.9814 79.0333 63.6327 78.3417 62.4465ZM73.7725 67.6218C73.5214 68.0502 73.1608 68.4041 72.7278 68.6473C72.2948 68.8904 71.8049 69.014 71.3084 69.0054H13.6916C13.1951 69.014 12.7052 68.8904 12.2722 68.6473C11.8392 68.4041 11.4786 68.0502 11.2275 67.6218C11 67.2367 10.88 66.7976 10.88 66.3502C10.88 65.9029 11 65.4638 11.2275 65.0787L40.0359 15.0486C40.2921 14.6222 40.6543 14.2694 41.0873 14.0244C41.5202 13.7795 42.0092 13.6508 42.5066 13.6508C43.004 13.6508 43.493 13.7795 43.9259 14.0244C44.3589 14.2694 44.7211 14.6222 44.9773 15.0486L73.7857 65.0787C74.0112 65.465 74.1289 65.9047 74.1266 66.352C74.1243 66.7994 74.002 67.2379 73.7725 67.6218ZM39.8646 47.9221V34.745C39.8646 34.0461 40.1423 33.3757 40.6365 32.8815C41.1307 32.3872 41.8011 32.1096 42.5 32.1096C43.199 32.1096 43.8693 32.3872 44.3635 32.8815C44.8578 33.3757 45.1354 34.0461 45.1354 34.745V47.9221C45.1354 48.621 44.8578 49.2914 44.3635 49.7856C43.8693 50.2799 43.199 50.5575 42.5 50.5575C41.8011 50.5575 41.1307 50.2799 40.6365 49.7856C40.1423 49.2914 39.8646 48.621 39.8646 47.9221ZM46.4531 59.7815C46.4531 60.5633 46.2213 61.3276 45.7869 61.9777C45.3525 62.6278 44.7351 63.1345 44.0128 63.4337C43.2905 63.7329 42.4956 63.8112 41.7288 63.6586C40.962 63.5061 40.2576 63.1296 39.7047 62.5767C39.1519 62.0239 38.7754 61.3195 38.6228 60.5527C38.4703 59.7858 38.5486 58.991 38.8478 58.2687C39.147 57.5463 39.6537 56.9289 40.3038 56.4946C40.9539 56.0602 41.7182 55.8283 42.5 55.8283C43.5484 55.8283 44.5539 56.2448 45.2953 56.9862C46.0366 57.7275 46.4531 58.733 46.4531 59.7815Z"
                  fill="url(#paint0_linear_1219_521)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1219_521"
                    x1="5.69305"
                    y1="8.12999"
                    x2="78.9788"
                    y2="73.759"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#16ABF8" />
                    <stop offset="1" stop-color="#25CFCB" />
                  </linearGradient>
                </defs>
              </svg>

              <CBox textAlign="center" mt="10px">
                Peringatan segera untuk detail kontrak yang hilang
              </CBox>
            </CFlex>

            <CFlex w="30%" align="center" justify="center" direction="column">
              <svg
                width="85"
                height="85"
                viewBox="0 0 85 85"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M45.1355 10.1491V16.2984H52.0754C53.3088 16.2984 54.514 16.6709 55.5331 17.3631L61.4961 21.4181C61.6402 21.5165 61.8124 21.5692 61.9881 21.5692H76.4021C77.101 21.5692 77.7713 21.8469 78.2656 22.3411C78.7598 22.8354 79.0375 23.5057 79.0375 24.2046C79.0375 24.9036 78.7598 25.5739 78.2656 26.0682C77.7713 26.5624 77.101 26.8401 76.4021 26.8401H70.8571L82.6849 53.8267C82.9221 54.3662 82.9715 54.9698 82.8249 55.5406C82.6784 56.1115 82.3445 56.6166 81.8767 56.9752C81.5253 57.2352 81.1634 57.4777 80.7874 57.699C79.8961 58.2309 78.9685 58.6994 78.0114 59.1011C74.8331 60.4303 71.4208 61.1101 67.9757 61.1005C64.532 61.1113 61.1209 60.4327 57.9436 59.1046C56.986 58.7028 56.0583 58.2331 55.1676 57.699C54.7948 57.4833 54.4346 57.2463 54.0889 56.9892L54.0713 56.9752C53.6035 56.6166 53.2696 56.1115 53.1231 55.5406C52.9765 54.9698 53.0258 54.3662 53.2631 53.8267L65.0979 26.8401H61.9846C60.7512 26.8401 59.5459 26.4676 58.5269 25.7754L52.5638 21.7203C52.419 21.6212 52.2474 21.5685 52.0719 21.5692H45.1355V72.5206H60.9023C61.6012 72.5206 62.2716 72.7983 62.7658 73.2925C63.26 73.7867 63.5377 74.4571 63.5377 75.156C63.5377 75.855 63.26 76.5253 62.7658 77.0196C62.2716 77.5138 61.6012 77.7915 60.9023 77.7915H24.0978C23.3989 77.7915 22.7285 77.5138 22.2343 77.0196C21.7401 76.5253 21.4624 75.855 21.4624 75.156C21.4624 74.4571 21.7401 73.7867 22.2343 73.2925C22.7285 72.7983 23.3989 72.5206 24.0978 72.5206H39.8646V21.5692H32.9247C32.7493 21.5691 32.5779 21.6218 32.4328 21.7203L26.4732 25.7754C25.4542 26.4676 24.2489 26.8401 23.0155 26.8401H19.9022L31.737 53.8267C31.9661 54.351 32.0183 54.9356 31.8858 55.4922C31.7533 56.0487 31.4433 56.5471 31.0026 56.9119C30.7215 57.1403 30.4404 57.3547 29.9133 57.6955C29.0246 58.271 28.0944 58.7796 27.1303 59.217C23.9566 60.6588 20.5102 61.4018 17.0244 61.3956C13.5384 61.403 10.0917 60.66 6.91842 59.217C5.95431 58.7796 5.02408 58.271 4.13542 57.6955C3.75963 57.4566 3.39716 57.1974 3.04962 56.9189C2.61242 56.55 2.30489 56.0507 2.17209 55.4942C2.0393 54.9377 2.08823 54.3534 2.31171 53.8267L14.143 26.8401H8.60157C7.90261 26.8401 7.23228 26.5624 6.73805 26.0682C6.24381 25.5739 5.96615 24.9036 5.96615 24.2046C5.96615 23.5057 6.24381 22.8354 6.73805 22.3411C7.23228 21.8469 7.90261 21.5692 8.60157 21.5692H23.0155C23.1912 21.5692 23.3634 21.5165 23.511 21.4181L29.467 17.3631C30.4861 16.6674 31.6948 16.2984 32.9282 16.2984H39.8646V10.1491C39.8646 9.45013 40.1423 8.7798 40.6365 8.28557C41.1308 7.79133 41.8011 7.51367 42.5 7.51367C43.199 7.51367 43.8693 7.79133 44.3636 8.28557C44.8578 8.7798 45.1355 9.45013 45.1355 10.1491ZM8.03935 53.89C10.8049 55.3623 13.8913 56.1287 17.0244 56.1213C20.1574 56.1287 23.2438 55.3623 26.0094 53.89L17.0244 33.404L8.03935 53.89ZM59.0259 53.8056C59.314 53.9462 59.6373 54.0973 59.9922 54.2484C61.8546 55.032 64.5778 55.8296 67.9757 55.8296C71.0735 55.8383 74.1331 55.1464 76.9256 53.8056L67.9757 33.4005L59.0259 53.8056Z"
                  fill="url(#paint0_linear_1219_526)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1219_526"
                    x1="-9.40174"
                    y1="-9.37"
                    x2="83.0258"
                    y2="78.1354"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#16ABF8" />
                    <stop offset="1" stop-color="#25CFCB" />
                  </linearGradient>
                </defs>
              </svg>
              <CBox textAlign="center" mt="10px">
                Memastikan perjanjian Anda selalu sesuai standar Hukum Indonesia
              </CBox>
            </CFlex>

            <CFlex w="30%" align="center" justify="center" direction="column">
              <svg
                width="85"
                height="85"
                viewBox="0 0 85 85"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1219_531)">
                  <path
                    d="M60.5712 21.089V69.2795C60.5712 72.4747 59.3019 75.5391 57.0426 77.7984C54.7832 80.0578 51.7189 81.3271 48.5236 81.3271H3.34506C6.54029 81.3271 9.60465 80.0578 11.864 77.7984C14.1234 75.5391 15.3927 72.4747 15.3927 69.2795V15.0652C15.3927 11.87 16.662 8.80561 18.9213 6.54624C21.1807 4.28688 24.2451 3.01758 27.4403 3.01758H71.1129"
                    stroke="url(#paint0_linear_1219_531)"
                    stroke-width="5.90333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M36.4759 24.1009H45.5116M30.4521 42.1723H45.5116M30.4521 60.2438H45.5116M71.1128 3.01758C73.9087 3.01758 76.59 4.12821 78.5669 6.10516C80.5439 8.08211 81.6545 10.7634 81.6545 13.5592V18.0771C81.6545 18.8759 81.3372 19.642 80.7723 20.2068C80.2075 20.7717 79.4414 21.089 78.6426 21.089H60.5712V13.5592C60.5712 10.7634 61.6818 8.08211 63.6587 6.10516C65.6357 4.12821 68.317 3.01758 71.1128 3.01758Z"
                    stroke="url(#paint1_linear_1219_531)"
                    stroke-width="5.90333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_1219_531"
                    x1="37.229"
                    y1="3.01758"
                    x2="37.229"
                    y2="81.3271"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#16ABF8" />
                    <stop offset="1" stop-color="#25CFCB" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_1219_531"
                    x1="56.0533"
                    y1="3.01758"
                    x2="56.0533"
                    y2="60.2438"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#16ABF8" />
                    <stop offset="1" stop-color="#25CFCB" />
                  </linearGradient>
                  <clipPath id="clip0_1219_531">
                    <rect
                      width="84.3333"
                      height="84.3333"
                      fill="white"
                      transform="translate(0.333221 0.00976562)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <CBox textAlign="center" mt="10px">
                Tersedia dalam bahasa lugas dan sederhana
              </CBox>
            </CFlex>
          </CFlex>
        </CBox>
      </CStack>
    </div>
  </div>
</template>

<script>
import HeaderDashboard from "@/components/header/HeaderDashboard.vue";
import { GET_USER } from "@/store/auth.module";
import config from "@/ConfigProvider";
import Loading from "vue-loading-overlay";
import ButtonBlue from "@/components/button/ButtonBlue.vue";
const CONTRACTPAL_API = config.value("CONTRACTPAL_API");
import axios from "axios";

export default {
  metaInfo: {
    title: "Contractpal",
    titleTemplate: "%s - Gethired.id",
  },
  components: {
    HeaderDashboard,
    Loading,
    ButtonBlue,
  },
  data() {
    return {
      isLoading: false,
      file: "",
      results: [
        // "Gaji dan Tunjangan:\n\n- (✔) Pasal 1 obliges PIHAK PERTAMA to pay honorarium (tunjangan) to PIHAK KEDUA on a monthly basis.\n- (✔) The amount of honorarium mentioned in the contract is Rp. 4,100,000,-\n- (✔) The contract states that the honorarium already includes the cost of jaminan sosial ketenagakerjaan (social security benefits).\n\nOverall, the contract mentions the obligation to pay a monthly honorarium and specifies a specific amount for the honorarium, which includes the social security benefits. However, it is important to note that the contract might not provide all the details related to salary and allowances. \n\nPlease refer to the applicable law and relevant regulations to ensure compliance with the complete requirements regarding salary and allowances.",
        // 'Based on the information provided in the contract, here is the analysis of the "Jam Kerja dan Lembur" (Working Hours and Overtime) section:\n\nJam Kerja:\n- (✔) Masa kerja pekerja/buruh dalam 1 (satu) hari kerja paling lama 8 (delapan) jam dan dalam 1 (satu) minggu kerja paling lama 40 (empat puluh) jam. This statement complies with the law as stated in Pasal 77 (1). It states that the maximum working hours for an employee in one working day is 8 (eight) hours and in one working week is 40 (forty) hours.\n\nLembur:\n- (X) The contract does not mention any specific provisions regarding overtime work (lembur). According to Pasal 78 (1), employers who require employees to work overtime must fulfill certain conditions, including obtaining the consent of the employees and limiting overtime work to a maximum of 3 hours per day and 14 hours per week. The contract should include these provisions in order to comply with the law.\n\nOverall, while the contract mentions the maximum working hours per day and week, it does not include specific provisions regarding overtime work, which is required by law. Therefore, the contract should be revised to include the necessary details and comply with the law.\n\nReferences:\n- Pasal 77 (1) Masa kerja pekerja/buruh dalam 1 (satu) hari kerja paling lama 8 (delapan) jam dan dalam 1 (satu) minggu kerja paling lama 40 (empat puluh) jam.\n- Pasal 78 (1) Pengusaha yang mempekerjakan pekerja/buruh melebihi waktu kerja sebagaimana dimaksud dalam Pasal 77 ayat (2) harus memenuhi syarat: a. ada persetujuan pekerja/buruh yang bersangkutan; dan b. waktu kerja lembur hanya dapat dilakukan paling banyak 3 (tiga) jam dalam 1 (satu) hari dan 14 (empat belas) jam dalam 1 (satu) minggu.',
        // 'Cuti Kerja:\n- (X) Tidak ada rincian ekspisit tentang "Cuti Kerja" atau cuti dari pekerjaan dalam kontrak tersebut.\n- (-) Mengacu pada Pasal 79 context yang menyebutkan bahwa pengusaha wajib memberikan waktu istirahat dan cuti kepada pekerja/karyawan.',
      ],
      webcv_url: config.value("WEBCV_URL"),
      evaluateTexts: [
        {
          label: "Gaji dan Tunjangan",
          value: "Gaji dan Tunjangan",
          checked: true,
        },
        {
          label: "Jam Kerja dan Lembur",
          value: "Jam Kerja dan Lembur",
          checked: true,
        },
        {
          label: "Cuti Kerja",
          value: "Cuti Kerja",
          checked: true,
        },
        {
          label: "Denda atau Penalti",
          value: "Denda atau Penalti",
          checked: true,
        },
        {
          label: "Hak dan Tanggung Jawab",
          value: "Hak dan Tanggung Jawab",
          checked: true,
        },
        {
          label: "Pemutusan Hubungan Kerja",
          value: "Pemutusan Hubungan Kerja",
          checked: true,
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    currentResults() {
      return this.$store.getters.currentResults;
    },
  },
  methods: {
    async getData() {
      this.isLoading = true;
      await this.$store.dispatch(GET_USER);
      this.isLoading = false;
    },
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    async submit() {
      this.isLoading = true;
      this.results = [];
      try {
        const rules = this.evaluateTexts
          ?.filter((item) => item.checked)
          .map((item) => item.label);
          
        if (this.file) {
          const promises = rules.map(async (rule) => {
            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("rule", rule);
            formData.append("cache_id", "uuid");
            const response = await axios.post(
              `${CONTRACTPAL_API}/contract`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            return response.data;
          });
          const items = await Promise.all(promises);
          console.log(items);
          this.results = items;
          this.isLoading = false;
        } else {
          alert("no file");
          this.isLoading = false;
        }
      } catch (err) {
        console.log("fail:", err);
      }
    },
    checkboxHandler(index, checked) {
      this.evaluateTexts[index].checked = checked;
    },
  },
};
</script>
